import { makeAutoObservable } from 'mobx';
import type PulseApi from '../../../../../api/PulseApi';
import { formatDate } from '../../../../../utils/date';
import type AuthStore from '../../../../login/store/AuthStore';
import type Bill from './Bill';

export default class BillingStore {
  constructor(
    private readonly api: PulseApi,
    private readonly authStore: AuthStore,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  getBillUrl(bill: Bill): string {
    if (!bill.isValid) {
      return '';
    }

    return this.api.utils.getBillingUrl(
      bill.provider?.id,
      `${formatDate(bill.startDate)}T00:00:00.000Z`,
      `${formatDate(bill.endDate)}T23:59:59.999Z`,
    );
  }

  downloadBill(bill: Bill) {
    const idToken = this.authStore.session?.idToken;
    const href = this.getBillUrl(bill);
    if (!href || !idToken) {
      return;
    }

    const url = new URL(href);
    url.searchParams.set('idToken', idToken);
    window.open(url.href, '_blank');
  }
}
